export const GET = 'get';

export const POST = 'post';

export const PUT = 'put';

export const PATCH = 'patch';

export const DELETE = 'delete';

export const API_RES_CODE_202 = 202;
